import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] border-t border-[#2A2A2A]">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <img 
              src="https://lirp.cdn-website.com/6920c96d/dms3rep/multi/opt/Revline+Rally-1920w.png" 
              alt="Revline Rally" 
              className="h-16 w-auto mb-4"
            />
            <p className="text-[#A19D98] max-w-md leading-relaxed">
              Where experiences hold memories, and strangers become family. 
              Curated road trips through Texas backroads for car enthusiasts.
            </p>
            <a
              href="https://www.instagram.com/revlinerally/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="inline-flex items-center gap-2 mt-6 text-[#F2EDE6] hover:text-[#E8651A] transition-colors"
            >
              <Instagram size={20} />
              <span>@revlinerally</span>
            </a>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-['Oswald'] text-sm uppercase tracking-wider text-[#A19D98] mb-4">
              Navigate
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" data-testid="footer-link-home" className="text-[#F2EDE6] hover:text-[#E8651A] transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/rallies" data-testid="footer-link-rallies" className="text-[#F2EDE6] hover:text-[#E8651A] transition-colors">
                  Rallies
                </Link>
              </li>
              <li>
                <Link to="/gallery" data-testid="footer-link-gallery" className="text-[#F2EDE6] hover:text-[#E8651A] transition-colors">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/sponsors" data-testid="footer-link-sponsors" className="text-[#F2EDE6] hover:text-[#E8651A] transition-colors">
                  Sponsors
                </Link>
              </li>
              <li>
                <Link to="/mission" data-testid="footer-link-mission" className="text-[#F2EDE6] hover:text-[#E8651A] transition-colors">
                  Mission
                </Link>
              </li>
              <li>
                <Link to="/faq" data-testid="footer-link-faq" className="text-[#F2EDE6] hover:text-[#E8651A] transition-colors">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-['Oswald'] text-sm uppercase tracking-wider text-[#A19D98] mb-4">
              Get in Touch
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/rallies#signup" data-testid="footer-link-signup" className="text-[#F2EDE6] hover:text-[#E8651A] transition-colors">
                  Join a Rally
                </Link>
              </li>
              <li>
                <Link to="/sponsors#contact" data-testid="footer-link-sponsor-contact" className="text-[#F2EDE6] hover:text-[#E8651A] transition-colors">
                  Become a Sponsor
                </Link>
              </li>
              <li>
                <Link to="/admin" data-testid="footer-link-admin" className="text-[#A19D98] hover:text-[#E8651A] transition-colors text-sm">
                  Admin
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-[#2A2A2A] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#A19D98] text-sm">
            © {currentYear} Revline Entertainment LLC. All rights reserved.
          </p>
          <p className="text-[#A19D98] text-sm font-['Oswald'] tracking-wider">
            MADE IN HOUSTON. BUILT FOR THE ROAD.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
